import { gql } from '@apollo/client'

import { useQuery } from 'hooks'

const USER_PROFESSIONAL_FIELD_LIST_QUERY = gql`
  query UserProfessionalFieldList {
    userProfessionalFieldList {
      id
      name
    }
  }
`

export const useUserProfessionalFieldListQuery = opts =>
  useQuery(USER_PROFESSIONAL_FIELD_LIST_QUERY, opts)
